import moment from 'moment'

export default function readableHour(secs) {
  return moment.unix(secs).format('HH:mm')
}
